import { css } from "@emotion/css";
import { Triangle } from "shared/components/atoms/Triangle";
import { Typography } from "shared/components/atoms/Typography";
import { zIndex } from "shared/styles";

const triangleCss = css({
  transform: "rotate(45deg)",
  position: "absolute",
  top: -5,
  right: -21,
});

const triangleTextCss = css({
  transform: "rotate(45deg)",
  top: 11,
  right: -1,
});

interface Props {
  className?: string;
}

export const Banner = ({ className }: Props) => {
  return (
    <div
      tw="bg-gradient-twilight-to-r w-full h-12 flex items-center relative"
      css={css({ zIndex: zIndex.fixed })}
      className={className}
    >
      <div tw="ml-6">
        <Typography
          fontWeight={600}
          fontSize={13}
          letterSpacing={0.28}
          color="#fff"
          tw="mb-2"
        >
          MIROR 無料占い🔮
        </Typography>
        <Typography
          fontWeight={400}
          fontSize={10}
          letterSpacing={0.82}
          color="#fff"
        >
          完全無料でプロの本格鑑定がLINEで届く!
        </Typography>
      </div>
      <Triangle color="#fb746e" size={33} className={triangleCss} />
      <span
        tw="font-base text-2xs text-white tracking-[.54px] absolute"
        className={triangleTextCss}
      >
        FREE
      </span>
    </div>
  );
};
